module.exports = __webpack_public_path__ + "img/53.e982629a.jpg";